import { render } from "./SupportRequestListPage.vue?vue&type=template&id=13f6974c&scoped=true&ts=true"
import script from "./SupportRequestListPage.vue?vue&type=script&lang=ts"
export * from "./SupportRequestListPage.vue?vue&type=script&lang=ts"

import "./SupportRequestListPage.vue?vue&type=style&index=0&id=13f6974c&lang=scss&scoped=true"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-13f6974c"]])

export default __exports__